var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import CloseIcon from "@mui/icons-material/Close";
import CopyAll from "@mui/icons-material/CopyAll";
import { Alert, Dialog } from "@mui/material";
import Button from "@mui/material/Button";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import { styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import copy from "copy-to-clipboard";
import { toDataURL } from "qrcode";
import * as React from "react";
import { toast } from "react-toastify";
import { formatCurrency, formatDate } from "../../util/utilitarios";
var BootstrapDialog = styled(Dialog)(function (_a) {
    var theme = _a.theme;
    return ({
        "& .MuiDialogContent-root": {
            padding: theme.spacing(2),
        },
        "& .MuiDialogActions-root": {
            padding: theme.spacing(1),
        },
    });
});
function BootstrapDialogTitle(props) {
    var children = props.children, onClose = props.onClose, other = __rest(props, ["children", "onClose"]);
    return (_jsxs(DialogTitle, __assign({ sx: { m: 0, p: 1, backgroundColor: "#034EA2", color: "white" } }, other, { children: [children, onClose ? (_jsx(IconButton, __assign({ "aria-label": "close", onClick: onClose, sx: {
                    position: "absolute",
                    right: 8,
                    top: 8,
                    color: "white",
                } }, { children: _jsx(CloseIcon, {}) }))) : null] })));
}
export function DialogPix(props) {
    var _a, _b, _c, _d, _e;
    var handleClose = props.handleClose;
    var debito = props.debito;
    var _f = React.useState(true), open = _f[0], setOpen = _f[1];
    var _g = React.useState(""), imagePix = _g[0], setImagePix = _g[1];
    var handleDialogClose = function () {
        setOpen(false);
        handleClose();
    };
    function handleCopyPix() {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                try {
                    copy(debito === null || debito === void 0 ? void 0 : debito.qrCode);
                    toast.success("QR code copiado!");
                }
                catch (error) {
                    console.log(error);
                }
                return [2 /*return*/];
            });
        });
    }
    React.useEffect(function () {
        function geraImagePix() {
            var _a, _b;
            return __awaiter(this, void 0, void 0, function () {
                var image;
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            if (!((_a = props.debito) === null || _a === void 0 ? void 0 : _a.qrCode)) return [3 /*break*/, 2];
                            return [4 /*yield*/, toDataURL((_b = props.debito) === null || _b === void 0 ? void 0 : _b.qrCode)];
                        case 1:
                            image = _c.sent();
                            setImagePix(image);
                            return [3 /*break*/, 3];
                        case 2:
                            handleClose();
                            _c.label = 3;
                        case 3: return [2 /*return*/];
                    }
                });
            });
        }
        geraImagePix();
    }, [debito]);
    return (_jsx(_Fragment, { children: _jsxs(BootstrapDialog, __assign({ onClose: handleDialogClose, "aria-labelledby": "customized-dialog-title", open: open, sx: {} }, { children: [_jsx(BootstrapDialogTitle, __assign({ id: "customized-dialog-title", onClose: handleClose }, { children: "Pagamento com pix" })), _jsxs("div", __assign({ style: cardBody }, { children: [_jsxs(Alert, __assign({ severity: "warning" }, { children: ["O tempo de compensa\u00E7\u00E3o do boleto pode variar conforme o banco escolhido para pagamento.", " ", _jsx("b", { children: "Pagar preferencialmente no aplicativo do Banco do Brasil." })] })), _jsx("div", __assign({ style: infoDescricao }, { children: _jsxs(Typography, __assign({ gutterBottom: true, fontWeight: "bold" }, { children: [(_a = debito === null || debito === void 0 ? void 0 : debito.debitos) === null || _a === void 0 ? void 0 : _a.descricaoTipoConta, " -", " ", formatDate(((_b = debito === null || debito === void 0 ? void 0 : debito.debitos) === null || _b === void 0 ? void 0 : _b.periodoReferencia) || "")] })) })), _jsxs("div", __assign({ style: contentInfoDescricao }, { children: [_jsx("span", __assign({ style: infoDescricao }, { children: _jsxs(Typography, __assign({ gutterBottom: true, fontWeight: "bold", paddingRight: 1 }, { children: ["Parcela:", " "] })) })), _jsx(Typography, __assign({ gutterBottom: true }, { children: ((_c = debito === null || debito === void 0 ? void 0 : debito.debitos) === null || _c === void 0 ? void 0 : _c.descricaoCota) || ((_d = debito === null || debito === void 0 ? void 0 : debito.debitos) === null || _d === void 0 ? void 0 : _d.numeroParcela) }))] })), _jsxs("div", __assign({ style: pixImage }, { children: [_jsx("img", { src: imagePix, alt: "", height: 200, width: 200 }), _jsx(Button, __assign({ sx: { backgroundColor: "#034EA2", marginBottom: 3 }, onClick: handleCopyPix }, { children: _jsx(CopyAll, { sx: { color: "white" } }) }))] })), _jsxs("div", __assign({ style: __assign(__assign({}, contentInfoDescricao), { width: "100%" }) }, { children: [_jsx("span", __assign({ style: infoDescricao }, { children: _jsx(Typography, __assign({ gutterBottom: true, fontWeight: "bold", paddingRight: 1 }, { children: "Valor:" })) })), _jsx(Typography, __assign({ gutterBottom: true }, { children: formatCurrency((_e = debito === null || debito === void 0 ? void 0 : debito.debitos) === null || _e === void 0 ? void 0 : _e.total) }))] })), _jsxs("div", __assign({ style: contentInfoDescricao }, { children: [_jsx("span", __assign({ style: infoDescricao }, { children: _jsxs(Typography, __assign({ gutterBottom: true, fontWeight: "bold", paddingRight: 1 }, { children: ["Pix v\u00E1lido na data de emiss\u00E3o:", " "] })) })), _jsx(Typography, __assign({ gutterBottom: true }, { children: new Date().toLocaleDateString("pt-br") }))] }))] }))] })) }));
}
var cardBody = {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    padding: "24px 32px",
    gap: "10px",
};
var infoDescricao = {
    fontWeight: "bold",
};
var contentInfoDescricao = {
    display: "flex",
};
var pixImage = {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
};
